<template>
<div class="flex">
  <img v-if="movie && movie.length !=0" :src="movie.response.banner" alt="">
  <vs-upload v-if="movie && movie.response" :action="`${this.$apiUrl}/movies/poster/${movie.response.id}`" fileName="banner"  limit="1" text="Banner Image" vs-tab="dfdf" :automatic="true" @on-success="successUpload" />
</div>

</template>

<script>
export default {
    props:['movie'],
  methods:{
    successUpload(){
      this.$vs.notify({color:'success',title:'Upload Success',text:''})
      setTimeout(() => {
        location.reload();  
      }, 1000);
      
    }
  }
}
</script>